export default "__VITE_PUBLIC_ASSET__23e97481__"